let local;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  local = true;
} else {
  local = false;
}

let api_url;

let windowUrl = window.location.origin + window.location.pathname;

if(local){
  api_url = "http://localhost:8080/api";
} else{
  api_url = windowUrl + "api";
}

export {
  api_url
};